<button mat-stroked-button color="primary" class="btn-ver" [class.solo-icono]="soloIcono"
  [disabled]="!habilitado" (click)="abrir()"
  [matTooltip]="habilitado ? 'Ver detalle del contrato' : 'Elegí un contrato primero'">

  <mat-spinner *ngIf="cargando" diameter="18" class="spinner"></mat-spinner>

  <ng-container *ngIf="!cargando">
    <mat-icon>visibility</mat-icon>
    <span *ngIf="!soloIcono">{{ texto }}</span>
  </ng-container>
</button>
